module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-development-277.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/contribution/vux-development.md
// module id = 720
// module chunks = 198